import React from 'react';
import { AppButton } from '@client/foundation/design-system/components';
import { AppDialog } from './app-dialog';

export type ConfirmationDialogProps = {
  open: boolean;
  title: string;
  description?: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  showCancelButton?: boolean;
  intent?: 'default' | 'danger';
  confirmDisabled?: boolean;
  onConfirm: () => void;
  onCancel?: () => void;
};

export type ConfirmationDialogWindowProps = Omit<
  ConfirmationDialogProps,
  'open'
>;

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  title,
  description,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  showCancelButton = true,
  intent = 'default',
  confirmDisabled = false,
  onConfirm,
  onCancel = () => {}
}) => {
  return (
    <AppDialog
      open={open}
      onClose={onCancel}
      title={title}
      description={description}
      actions={
        <>
          {showCancelButton ? (
            <AppButton tone="secondary" onClick={onCancel}>
              {cancelLabel}
            </AppButton>
          ) : null}
          <AppButton
            tone={intent === 'danger' ? 'danger' : 'primary'}
            onClick={onConfirm}
            disabled={confirmDisabled}
          >
            {confirmLabel}
          </AppButton>
        </>
      }
    />
  );
};
